import React, { Component } from 'react';
import './Contact.css'


class Contact extends Component {
  render() {
    return (
      <div className="contact" id="contact">
       <div className="conhead" >
                    <h3>Reach out and send me a friendly hello.</h3>
                    <h1>LET'S HAVE A CHAT</h1>
         </div>
         <div className="incont" >
            <input className="conin" type="text" id="fname" name="fname" placeholder="Your Name *" />   
          </div>   
          <div className="incont" >
            <input className="conin" type="text" id="fname" name="fname" placeholder="Your Email *" />   
          </div>   
          <div className="incont" >
            <input className="conin" type="text" id="fname" name="fname" placeholder="Subject *" />   
          </div>   
          <div >
            <textarea className="textareacont" type="text" id="fname" name="fname" placeholder="Your Message *" />   
          </div>  
            <div className="contbtn">
            <button className="contbutton button2">Send Message</button>
            </div>
            

      </div>
    );
  }
}

export default Contact;





 